import { warn } from "./log";
// Tiny locally-generated sound effects (Web Audio), no assets.
const KEY = "byc-muted";
let ctx = null;
let muted = typeof sessionStorage !== "undefined" && sessionStorage.getItem(KEY) === "1";

const getCtx = () => {
  const C = window.AudioContext || window.webkitAudioContext;
  if (!C) return null;
  if (!ctx) ctx = new C();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

const tone = (c, { freq, to, start = 0, dur, type = "sine", vol = 0.05 }) => {
  const t0 = c.currentTime + start;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  if (to) osc.frequency.exponentialRampToValueAtTime(to, t0 + dur);
  gain.gain.setValueAtTime(0.0001, t0);
  gain.gain.exponentialRampToValueAtTime(vol, t0 + 0.012);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(gain).connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.02);
};

const play = (fn) => {
  if (muted) return;
  try {
    const c = getCtx();
    if (c) fn(c);
  } catch (e) {
    warn("Effetto sonoro non riprodotto", e);
  }
};

export const sfx = {
  isMuted: () => muted,
  setMuted: (m) => {
    muted = m;
    sessionStorage.setItem(KEY, m ? "1" : "0");
  },
  spin: () =>
    play((c) => {
      tone(c, { freq: 260, to: 620, dur: 0.22, type: "triangle", vol: 0.04 });
      [0.05, 0.1, 0.16, 0.24].forEach((s, i) => tone(c, { freq: 900 + i * 60, start: s, dur: 0.035, vol: 0.018 }));
    }),
  assign: () =>
    play((c) => {
      tone(c, { freq: 660, dur: 0.09, vol: 0.045 });
      tone(c, { freq: 990, start: 0.07, dur: 0.14, vol: 0.04 });
    }),
};
